














import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IWebhookEvent } from "@/models/webhooks";

@Component
export default class WebhookEventStatusIcon extends Vue {
  // Props

  @Prop({ required: true })
  public webhookEvent!: IWebhookEvent;

  // Computed

  public get statusIcon() {
    return this.$store.getters[
      `data/${DataModules.WEBHOOKS_EVENTS}/getEventMappedStatus`
    ](this.webhookEvent.status);
  }
}
